import React, { Component } from "react";
import $ from "jquery";
import PdfViewer from "./PdfViewer";

class ReportContrasteCobranzaModal extends Component {

    componentDidMount() {
        this.closeAction();
    }

    closeAction = () => {
        const { cleanData } = this.props;
        $("#reportContrasteCobranzaModal").on("hidden.bs.modal", function () {
            cleanData();
        });
    };

    render() {
        const { ReportsModel, ActualDate, ChangeInitialDate, ChangeFinalDate, GenerateReport, ListReports, ShowPDFViewerModal, ShowPDFViewer, MailTools, printhide, ShowFormatToPrint, _user, sucursales } = this.props;

        const isMaestra = Number(_user?.Branch?.Type) === 3;
        const sucursalUsuario = (sucursales || []).find(s => s.pk_Sucursal === Number(_user?.Branch?.IdBranch));
        const isPlanta = Number(sucursalUsuario?.Type) === 2;
        const isZonal = Number(sucursalUsuario?.Type) === 1;
        const plantas = (sucursales || []).filter(s => Number(s.Type) === 2);
        const plantaId = isMaestra ? ReportsModel.Planta : String(_user?.Branch?.IdBranch || '');
        const plantaSeleccionada = (sucursales || []).find(s => s.pk_Sucursal === Number(plantaId));
        const sucursalZonalUsuario = isZonal ? (sucursales || []).find(s => s.pk_Sucursal === Number(_user?.Branch?.IdBranch)) : null;
        const prefixZonal = sucursalZonalUsuario?.project?.substring(0, 2) || '';
        const plantaDelZonal = isZonal ? (sucursales || []).find(s => Number(s.Type) === 2 && s.project?.substring(0, 2) === prefixZonal) : null;
        const prefixPlanta = isZonal ? prefixZonal : plantaSeleccionada?.project?.substring(0, 2) || '';
        const zonales = (sucursales || []).filter(s => Number(s.Type) === 1 && s.project?.substring(0, 2) === prefixPlanta);
        const hayPlantaSeleccionada = plantaId && plantaId !== '---';

        if (isZonal && (!ReportsModel.Sucursal || ReportsModel.Sucursal === '---')) { ReportsModel.Sucursal = String(_user?.Branch?.IdBranch || '---'); }
        else if (zonales.length === 1 && (!ReportsModel.Sucursal || ReportsModel.Sucursal === '---')) { ReportsModel.Sucursal = String(zonales[0].pk_Sucursal); }

        return (
            <div className="modal fade" id="reportContrasteCobranzaModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header" style={{ background: "#343a40" }}>
                            <h5 style={{ color: "white" }}>Reporte de Contraste Cobranza</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{ color: "white" }}><span aria-hidden="true">&times;</span></button>
                        </div>
                        <div className="modal-body">
                            <div className="mt-2">
                                <div className="row">
                                    <div className="col-12 col-lg-6">
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend"><span className="input-group-text"><strong>Desde</strong></span></div>
                                            <input type="date" className="form-control" max={ActualDate} value={ReportsModel.InitialDate}
                                                onChange={(event) => ChangeInitialDate(event)}
                                                onBlur={(event) => { const desde = event.target.value; const hasta = ReportsModel.FinalDate; if (hasta && desde > hasta) { ChangeInitialDate({ nativeEvent: { target: { value: hasta } } }); } }} />
                                        </div>
                                    </div>

                                    <div className="col-12 col-lg-6">
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend"><span className="input-group-text"><strong>Hasta</strong></span></div>
                                            <input type="date" className="form-control" max={ActualDate} value={ReportsModel.FinalDate}
                                                onChange={(event) => ChangeFinalDate(event)}
                                                onBlur={(event) => { const hasta = event.target.value; const desde = ReportsModel.InitialDate; if (desde && hasta < desde) { ChangeFinalDate({ nativeEvent: { target: { value: desde } } }); } }} />
                                        </div>
                                    </div>

                                    {(isMaestra || isPlanta || isZonal) &&
                                        <div className="col-12 col-lg-6">
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend"><span className="input-group-text"><strong>Planta</strong></span></div>
                                                {isMaestra ? (
                                                    <select className="form-control" value={ReportsModel.Planta || '---'} onChange={(event) => { ReportsModel.Planta = event.target.value; ReportsModel.Sucursal = '---'; this.forceUpdate(); }}>
                                                        <option value="---" disabled>--- Selecciona ---</option>
                                                        {plantas.map((p, i) => (<option key={i} value={p.pk_Sucursal}>{p.nombre}</option>))}
                                                    </select>
                                                ) : (
                                                    <input type="text" className="form-control" disabled value={isZonal ? plantaDelZonal?.nombre || '' : plantaSeleccionada?.nombre || ''} />
                                                )}
                                            </div>
                                        </div>
                                    }

                                    {(isMaestra || isPlanta || isZonal) &&
                                        <div className="col-12 col-lg-6">
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend"><span className="input-group-text"><strong>Zonal</strong></span></div>
                                                {isZonal ? (
                                                    <input type="text" className="form-control" disabled value={sucursalZonalUsuario?.nombre || ''} />
                                                ) : (
                                                    <select className="form-control" disabled={!hayPlantaSeleccionada} value={ReportsModel.Sucursal || '---'} onChange={(event) => { ReportsModel.Sucursal = event.target.value; this.forceUpdate(); }}>
                                                        {zonales.length > 1 && <option value="---" disabled>--- Selecciona ---</option>}
                                                        {zonales.map((z, i) => (<option key={i} value={z.pk_Sucursal}>{z.nombre}</option>))}
                                                    </select>
                                                )}
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                            <button type="button" className="btn btn-primary"
                                onClick={() => GenerateReport({
                                    InitialDate: ReportsModel.InitialDate,
                                    FinalDate: ReportsModel.FinalDate,
                                    Planta: isMaestra ? (ReportsModel.Planta || '---') : isZonal ? String(plantaDelZonal?.pk_Sucursal || '---') : String(_user?.Branch?.IdBranch || '---'),
                                    Sucursal: isZonal ? String(_user?.Branch?.IdBranch || '---') : (ReportsModel.Sucursal || '---'),
                                })}>
                                Generar
                            </button>
                        </div>
                    </div>
                </div>

                {ShowPDFViewerModal &&
                    <PdfViewer
                        DocsToPrint={ListReports}
                        TypeDoc={"Report_ContrasteCobranza"}
                        EnableEditButton={false}
                        Editable={false}
                        ChangeEditableMode={false}
                        EditableDocModel={""}
                        RefreshDocModel={""}
                        SaveChanges={""}
                        UploadDoc={""}
                        EditParam1={false}
                        ShowPDFViewer={ShowPDFViewer}
                        user={"user"}
                        Counter={true}
                        MailTools={MailTools}
                        ReportsModel={ReportsModel}
                        printhide={printhide}
                        ShowFormatToPrint={ShowFormatToPrint}
                        reprint={false}
                    />
                }
            </div>
        );
    }
}

export default ReportContrasteCobranzaModal;